import React from "react";

const BrokerLogo = ({ type }) => (
  <span className={`broker-logo broker-logo--${type}`}>
    {type === "dhan" ? "ध" : type === "fyers" ? "F" : <i className="fa fa-signal" aria-hidden="true"></i>}
  </span>
);

export default BrokerLogo;
